<template>
  <div>
    <span class="label mr-1">Default Tax Zone (New Customers)</span>
    <Tooltip placement="top">
      <template #trigger>
        <div class="d-flex align-items-center">
          <i class="fas fa-question-circle"></i>
        </div>
      </template>
      <template #tooltip>
        <div class="text-center">
          This will be used as the default tax zone when configuring new taxable
          customers and addresses.
        </div>
      </template>
    </Tooltip>
  </div>
</template>
